import React, { useState, useEffect } from 'react';
import './Appointment.css';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import api from "../api";;

const timeSlots = [
  "09:00", "10:00", "11:00", "12:00", "13:00",
  "16:00", "17:00", "18:00", "19:00"
];

export default function BookAppointment() {
  const [date, setDate] = useState(new Date());
  const [bookedSlots, setBookedSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState('');
  const [reason, setReason] = useState('');
  const [status, setStatus] = useState('');
  const [showAppointment, setShowAppointment] = useState(false);
  const formattedDate = date.toISOString().split('T')[0];
  const [sessionType, setSessionType] = useState('offline'); // default is offline




const token = localStorage.getItem("token");

useEffect(() => {
  if (!token) return;

  api.get(`/api/appointments/${formattedDate}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true, // axios equivalent of credentials: "include"
  })
    .then(res => {
      const data = res.data;
      setBookedSlots(data.booked_slots || []);
    })
    .catch(err => {
      console.error("Error fetching appointments:", err);
    });
}, [formattedDate, token]);

const [myAppointment, setMyAppointment] = useState(null);

useEffect(() => {
  const fetchMyAppointment = async () => {
    try {
      const res = await api.get("/api/appointments/my", {
        withCredentials: true, // axios equivalent of fetch credentials
      });

      const data = res.data;

      if (data?.appointment?.date && data?.appointment?.time) {
        setMyAppointment({
          date: data.appointment.date,
          time: data.appointment.time,
          reason: data.appointment.reason || "",
          session_type: data.appointment.session_type || "offline",
          meet_link: data.appointment.meet_link || null,
        });
      } else {
        setMyAppointment(null);
      }

      console.log("Fetched appointment data:", data);
    } catch (err) {
      console.error("Failed to fetch user appointment:", err);
    }
  };

  if (token) fetchMyAppointment();
}, [token]);

  const cancelAppointment = async () => {
  if (!myAppointment) return;

  const confirmCancel = window.confirm("Are you sure you want to cancel this appointment?");
  if (!confirmCancel) return;

  try {
  const res = await api.delete(
    `/api/appointments/${myAppointment.date}/${myAppointment.time}`,
    {
      withCredentials: true, // axios equivalent of fetch credentials
    }
  );

  const result = res.data;

  if (res.status === 200) {
    alert("Appointment cancelled.");
    setMyAppointment(null);
    setBookedSlots((prev) =>
      prev.filter((slot) => slot !== myAppointment.time)
    );
  } else {
    alert(result.error || "Failed to cancel.");
  }
} catch (err) {
  console.error("Cancel error:", err);
  alert("Something went wrong while cancelling the appointment.");
}

};

  const bookAppointment = async () => {
  try {
    const res = await api.post(
      "/api/appointments/book",
      {
        date: formattedDate,
        time: selectedSlot,
        reason: reason,
        session_type: sessionType,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true, // replaces fetch's credentials: "include"
      }
    );

    const result = res.data;

    if (res.status === 200) {
      setStatus("Appointment booked successfully!");
      setSelectedSlot("");
      setReason("");
      setBookedSlots((prev) => [...prev, selectedSlot]); // disable booked slot immediately
    } else {
      setStatus(result.error || "Error booking appointment.");
    }
  } catch (err) {
    console.error("Error booking appointment:", err);
    setStatus("Something went wrong while booking.");
  }
};


  return (
    <div className="appointment-page">
  <Header />
  <div className="appointment-body">
    <Sidebar />
    <div className="appointment-content">
          <h2 className="appointment-title">Book an Appointment</h2>

          <div className="form-group">
            <label className="label">Session Type:</label>
            <select className="dropdown" value={sessionType} onChange={(e) => setSessionType(e.target.value)}>
              <option value="offline">Offline</option>
              <option value="online">Online (Google Meet)</option>
            </select>
          </div>

          <div className="form-group">
            <label className="label">Select Date:</label>
            <DatePicker
              selected={date}
              onChange={(date) => setDate(date)}
              dateFormat="yyyy-MM-dd"
              minDate={new Date()}
              className="datepicker-input"
            />
          </div>

          <div className="form-group">
            <label className="label">Available Time Slots:</label>
            <div className="time-slots">
              {timeSlots.map(slot => (
                <button
                  key={slot}
                  className={`time-slot-button ${
                    bookedSlots.includes(slot)
                      ? 'disabled'
                      : selectedSlot === slot
                      ? 'selected'
                      : ''
                  }`}
                  disabled={bookedSlots.includes(slot)}
                  onClick={() => setSelectedSlot(slot)}
                >
                  {slot}
                </button>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label className="label">Reason:</label>
            <textarea
              className="textarea"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows="4"
            />
          </div>

          {myAppointment ? (
  <>
    <h2>You Already Have an Appointment</h2>
    <button
      className="toggle-appointment-button"
      onClick={() => setShowAppointment(prev => !prev)}
    >
      {showAppointment ? "Hide" : "View"} My Appointment
    </button>

    {showAppointment && (
      <div className="booked-info">
        <h3>Your Upcoming Appointment</h3>
        <p>
          <strong>Date:</strong> {myAppointment.date}<br />
          <strong>Time:</strong> {myAppointment.time}<br />
          <strong>Reason:</strong> {myAppointment.reason || "Not specified"}
          <strong>Session Type:</strong> {myAppointment.session_type}<br />
          {myAppointment.session_type === "online" && myAppointment.meet_link && (
            <>
              <strong>Meet Link:</strong> <a href={myAppointment.meet_link} target="_blank" rel="noreferrer">{myAppointment.meet_link}</a><br />
            </>
          )}
        </p>
        <button className="cancel-button" onClick={cancelAppointment}>
          Cancel Appointment
        </button>

      </div>

    )}
  </>
) : (
  <>
    <p>No appointment booked.</p>
    <button
      className="book-button"
      onClick={bookAppointment}
      disabled={!selectedSlot || !reason}
    >
      Book Appointment
    </button>
  </>
)}



          {status && <p className="status-message">{status}</p>}
        </div>
      </div>
      <Footer />
    </div>
  );
}
